import React, { useEffect, useState } from 'react';
import { SubHeader } from '../../../utils/componentes-utiles/SubHeader';
import { CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, Grid, Typography } from '@mui/material';
import { getEmpleadosProyectos, getRolesYDepartamentos } from '../../../services/apis';
import { PermisosOpciones } from './PermisosOpciones';
import { EmpleadosProyectos } from './EmpleadosProyectos';

export const RolesYDepartamentos = () => {
    const [opciones, setOpciones] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [roles, setRoles] = useState([]);
    const [empleadosProyectos, setEmpleadosProyectos] = useState([]);
    const [proyectos, setProyectos] = useState([])

    const cargarOpciones = async () => {

        try {
            const response = await getRolesYDepartamentos();

            console.log('Opciones cargadas:', response.data);

            setOpciones(response.data.opciones);
            setRoles(response.data.roles);
            setLoaded(true);
        } catch (error) {
            console.error('Error al cargar las opciones:', error);
        }
    };

    const cargarEmpleadosProyectos = async () => {
        try {
            const response = await getEmpleadosProyectos();


            if (response.success) {
                setEmpleadosProyectos(response.data.usuarios)
                setProyectos(response.data.proyectos)
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }


    useEffect(() => {
        cargarEmpleadosProyectos();
        cargarOpciones();
    }, []);



    return (
        <Grid container justifyContent={'center'} xs={12}>
            <SubHeader titulo={'ROLES, DEPARTAMENTOS Y EMPLEADOS'} />

            {!loaded && <CircularProgress />}
            {loaded && (
                <>
                    {opciones.map((opcion, index) => (
                        <>
                            <PermisosOpciones roles={roles} opciones={opcion.opciones} title={opcion.nombre} nombreArray={opcion.url} descripcion={opcion.descripcion} index={index} />
                        </>
                    ))}

                    <EmpleadosProyectos empleados={empleadosProyectos} setEmpleadosProyectos={setEmpleadosProyectos} opciones={proyectos} title={opciones[0].nombre} nombreArray={opciones[0].url} descripcion={opciones[0].descripcion} index={100}></EmpleadosProyectos>
                </>
            )}
        </Grid>
    );
};
